import React, { useEffect, useState } from "react";
import GrowImg from "../../assets/grow.webp";
const Grow = () => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Get container width
    const container = document.getElementById("text-container");
    setWidth(container.offsetWidth);

    // Handle window resize
    const handleResize = () => {
      setWidth(container.offsetWidth);
    };
    window.addEventListener("resize", handleResize);

    // Animation setup
    const textElement = document.getElementById("animated-text");
    const textWidth = textElement.offsetWidth;

    // Create a seamless loop by setting initial position
    // We need the text to already be partially visible on screen
    let position = 0;

    // Animation function
    const animate = () => {
      position -= 1; // Speed of movement (reduced for smoother scrolling)

      // Reset position for seamless loop
      // When the first part moves out of view, reset to create continuous effect
      if (position <= -textWidth / 5) {
        position = 0;
      }

      textElement.style.transform = `translateX(${position}px)`;
      requestAnimationFrame(animate);
    };

    // Start animation
    const animationId = requestAnimationFrame(animate);

    // Cleanup function
    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div className="relative overflow-hidden container mx-auto">
        <div className="absolute inset-0 bg-gradient-to-br" />
        {/* Content */}
        <div className="relative flex flex-col items-center justify-center mt-32 text-center">
          <div id="text-container" className="w-full overflow-hidden">
            <h1
              id="animated-text"
              className="text-5xl md:text-6xl font-bold text-white mb-8 whitespace-nowrap"
              style={{
                position: "relative",
                display: "inline-block",
                width: "auto",
              }}
            >
              Innovate Grow Succeed Innovate Grow Succeed Innovate Grow Succeed
              Innovate Grow Succeed Innovate Grow Succeed Innovate Grow Succeed
              Innovate Grow Succeed Innovate Grow Succeed Innovate Grow Succeed
            </h1>
          </div>
        </div>
      </div>
      <div className="relative w-full overflow-hidden">
        {/* Content */}
        <div className=" relative z-10 flex h-full flex-col lg:flex-row items-center mt-10">
          {/* Text Content */}
          <div className="flex items-center justify-center lg:justify-end w-full  lg:mt-0">
            <img
              style={{ animationDuration: "3s" }}
              className="h-auto w-[300px] sm:w-[500px] lg:w-[700px] animate-float rounded-lg"
              src={GrowImg}
              alt="Server"
            />
          </div>
          <div className="max-w-2xl text-center lg:text-left  mt-20 lg:mt-0">
            <h1 className="mb-4 text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
              Join Our Team
            </h1>
            <p className="text-lg text-gray-400 mt-6">
              At <b> Multify Solutions Private Limited, </b> we are redefining
              financial technology with innovation, agility, and excellence. As
              a subsidiary of Shri Ram Finance Corporation, we are committed to
              revolutionizing digital finance solutions while fostering a
              dynamic and growth-oriented work environment. Whether you are an
              experienced professional or a fresh graduate, Multify Solutions
              offers exciting career opportunities where you can thrive,
              innovate, and make a real impact.
            </p>
          </div>

          {/* Image Container */}
        </div>
      </div>
    </div>
  );
};

export default Grow;
